import axios from 'axios';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { sortInAlphabeticalOrder } from '../common-helpers/commonServices';

const NEET_CombinedTestManagementModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const [topics, setTopics] = useState([]);
    const [subjectWiseTopics, setSubjectWiseTopics] = useState([]);
    const [subject, setSubject] = useState({});
    const [assignedQuestions, setAssignedQuestions] = useState(0);
    const [subjects, setSubjects] = useState([]);
    const [selectedSubject, setSelectedSubject] = useState({});
    const [synchChanges, setsynchChanges] = useState(false);
    console.log(subjects);


    useImperativeHandle(ref, () => ({
        openModal(item) {
            setSubject(item);
            setModalBox(true);
        }
    }));
    useEffect(() => {
        if (selectedSubject?.Sn) {
            const filterdTopics = topics.filter(data => data.SubjectID == selectedSubject.Sn);
            setSubjectWiseTopics(filterdTopics);
        }
    }, [selectedSubject.Sn, synchChanges])

    useEffect(() => {
        if (!subject.Sn) return
        async function fetchData() {
            try {
                const response = await axios.get(BACKEND_SERVER_URL + '/neet/topics/');
                const response2 = await axios.get(BACKEND_SERVER_URL + '/neet/subjects/');
                const response3 = await axios.get(BACKEND_SERVER_URL + '/neet/assigned-combined-quetions');
                let topics = response.data.topics;
                topics?.forEach(data => {
                    data.TempNoOfQuestion = data.NoOfQuestion;
                    data.NoOfQuestion = data.CombinedNoOfQuestion;
                })
                setTopics(sortInAlphabeticalOrder(topics, 'Section'));
                setSubjects(response2.data.subjects);
                response2.data.subjects.pop();
                setSelectedSubject(response2.data.subjects[0]);
                setAssignedQuestions(response3.data.assignedQuestions);
            } catch (error) {
                console.log(error);
                toast.error(error.response?.data?.message || "An error occurred while fetching subjects and sections.");
            }

        }
        fetchData();
        return () => {
            setAssignedQuestions(0);
            setSelectedSubject({});
            setSubject({});
        };

    }, [subject])

    const handleSaveTopic = async () => {
        try {
            const updatedTopics = topics.map(data => {
                return {
                    ...data,
                    CombinedNoOfQuestion: data.NoOfQuestion,
                    NoOfQuestion: data.TempNoOfQuestion
                }
            })
            const response = await axios.post(
                BACKEND_SERVER_URL + '/neet/updateTestManagement/', updatedTopics?.map(data => ({ Sn: data.Sn, NoOfQuestion: data.NoOfQuestion, CombinedNoOfQuestion: data.CombinedNoOfQuestion, isUpdated: data.isUpdated || false }))
            );

            toast.success(response.data.message);
            props.setSubjectLoading(!props.loadSubjects);
            setModalBox(false);
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Something went wrong");
        }
    };


    const handleQNumberChange = (Sn, value) => {
        value = Number(value);
        let copy = [...topics];
        let selectedToic = copy.find((topic, index) => topic.Sn == Sn);
        let preNumber = Number(selectedToic?.NoOfQuestion);
        if (value > preNumber) {
            setAssignedQuestions(prev => prev + (value - preNumber));
        } else if (value < preNumber) {
            setAssignedQuestions(prev => prev - (preNumber - value));
        }
        selectedToic.NoOfQuestion = value;
        selectedToic.isUpdated = true;
        setTopics(sortInAlphabeticalOrder(copy, 'Section'));
        setsynchChanges(!synchChanges);
    }

    return (
        <Modal
            onHide={() => setModalBox(false)}
            show={modalBox}
            size="xl"
            backdrop="static"
            keyboard={false}
        >
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">
                        Test Management
                    </h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>

                <div className=" px-4 pb-0">
                    <div className="d-flex w-100 justify-content-between align-items-center mt-0 pt-0">
                        {/* Subject Badge */}
                        <span
                            className={`p-1 px-3 fw-bold text-white ${assignedQuestions === subject.QuestionCount ? "bg-success" : "bg-danger"
                                } fs-4 border border-2 rounded`}
                        >
                            {subject.Subject}
                        </span>

                        {/* Subject Selector */}
                        <div className="w-25">
                            <Select
                                value={
                                    selectedSubject?.Sn
                                        ? { value: selectedSubject, label: selectedSubject.Subject }
                                        : null
                                }
                                onChange={(opt) => setSelectedSubject(opt.value)}
                                options={subjects?.map((s) => ({ value: s, label: s.Subject }))}
                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: "100%",
                                        backgroundColor: "transparent",
                                        borderColor: "#17a2b8",
                                    }),
                                }}
                                placeholder="Select Subject"
                            // isClearable
                            />
                        </div>

                        {/* Total Questions Badge */}
                        <span
                            className={`p-1 px-3 fw-bold text-white ${assignedQuestions === subject.QuestionCount ? "bg-success" : "bg-danger"
                                } fs-4 border border-2 rounded`}
                        >
                            Total Questions: {assignedQuestions}
                        </span>
                    </div>



                    <div className="d-flex w-100 justify-content-around mb-3">
                        <div className="mb-3  col-12">
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-md table display dataTablesCard student-tab 
                                                                dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center  border border-left'>
                                                {/* <th className=' custom-table-header p-2'>SN</th> */}
                                                <th className=' custom-table-header p-2 text-start'>SECTIONS</th>
                                                <th className=' custom-table-header p-2  ps-3'>Topics</th>
                                                <th className=' custom-table-header p-2  ps-3'>Assigned Qs.</th>
                                                <th className=' custom-table-header p-2  ps-3'>Available Qs.</th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {subjectWiseTopics?.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'} `} >


                                                    <td className='p-1' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between ">
                                                            <h6 className='mb-0 ps-3' style={{ fontSize: '13px', fontWeight: 'bold' }}>{item.Section}

                                                            </h6>
                                                        </div>
                                                    </td>

                                                    <td className='p-1 text-start' style={{ border: "1px solid #cccccc" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.Topic}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <input type="number" name={`${ind} questionCount`} className="form-control p-0 px-2" style={{ height: '1.75rem', lineHeight: '1.75rem', fontSize: '0.875rem' }} value={item?.NoOfQuestion ?? 0} min={0} onChange={(e) => handleQNumberChange(item.Sn, e.target.value)} />

                                                    </td>
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "65px" }}>
                                                        <h6 className="mb-0 ">
                                                            {item.AvailableQuestions ?? 0}
                                                        </h6>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs" onClick={handleSaveTopic}>
                        Update Topic
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default NEET_CombinedTestManagementModal;
